import { FEMALE_BENEFITS, OUTPATION_BENEFITS } from "context/apiContext";
import { getCoverageOptionsVisibleFields } from "./CoverageOptionsVisibility";

/**
 * Which benefit rows the Summary step's accordion should render, given the
 * current selections. Mirrors useSteps.jsx's benefitsGenerator(-1) - passing
 * -1 makes every isValidStep() check there short-circuit to true, so the
 * whole generator reduces to this pure function of already-shared state
 * (useSteps.jsx itself stays untouched, it also gates the quoter's wizard
 * step-navigation). Reuses getCoverageOptionsVisibleFields for the part of
 * the logic already extracted for the Coverage Options step.
 */
export const getVisibleAccordionBenefits = ({
    selectedBenefitsIds = {},
    isCountryResidenceDeductible = false,
    outpationBenefitsEnabled = false,
    addDependant = false,
    outpationBenefitsmaternidad = false,
    step14Confirmation = false,
} = {}) => {
    const visible = [
        ...getCoverageOptionsVisibleFields(selectedBenefitsIds, isCountryResidenceDeductible),
        "congenit",
        "hazardsp",
        "inmental",
        "deductbl",
        "eyesurgr",
    ];

    if (addDependant) {
        visible.push("deathcov");
    }

    if (outpationBenefitsEnabled) {
        visible.push(...OUTPATION_BENEFITS);
    }

    if (outpationBenefitsmaternidad) {
        visible.push(...FEMALE_BENEFITS);
    }

    if (step14Confirmation) {
        visible.push("healthch");
    }

    return visible;
};
